export enum StorageKey {
    HasSetAttributes = 'hasSetAttributes',
}
